import { ErpCustomerOrderState } from "./erpCustomerOrderState";
import { OrderSortingType } from "./orderSortingType";

export class OrderSearchRequestDto {
	public orderSearchTerm: string = "";
	public articleSearchTerm: string = "";
	public dateFrom: Date | null = null;
	public dateTo: Date | null = null;
	public sortingType: OrderSortingType = OrderSortingType.OrderDateAscending;
	public includeStorniert: boolean = true;
	public includeOtherPositions: boolean = true;
	public states: ErpCustomerOrderState[] = [];
	public fertigerIds: number[] = [];
	public weightOfASinglePositionGreaterThen: number = 0;
	public quantityOfASinglePositionGreaterThen: number = 0;
	public numberOfPositionsLessThen: number = 0;
}
